function setCookie(cname, cvalue, exdays) {
	var d = new Date();
	d.setTime(d.getTime() + (exdays*24*60*60*1000));
	var expires = "expires="+ d.toUTCString();
	var domain = location.hostname; // Get the website's domain (e.g., 'example.com')
	var path = "/";

	document.cookie = cname + "=" + cvalue + "; " + expires + "; domain=" + domain + "; path=" + path;
}

function getCookie(cname) {
	var name = cname + "=";
	var ca = document.cookie.split(';');
	for(var i=0; i<ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0)==' ') c = c.substring(1);
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}

function trackMidaEvent(eventName) {
	if (!eventName) return;

	window.mdq = window.mdq || [];
	window.mdq.push(['track', eventName]);
	console.log('tracked',eventName)
}

function getPreorderPropertyValue(sourceElement) {
	if (!sourceElement?.dataset) return 'Pre-order';

	return (sourceElement.dataset.preorderMessage || 'Pre-order').trim();
}

function getPreorderDisplayMessage(sourceElement) {
	const preorderMessage = sourceElement?.dataset?.preorderMessage?.trim() || '';
	return preorderMessage ? `Pre-order - ${preorderMessage}` : 'Pre-order';
}

// Mida Event Tracking
document.addEventListener('click', function(event) {
	const swatch = event.target.closest('.product-card-swatches [data-product-card-swatch]');
	if (swatch) {
		trackMidaEvent('product_swatch_click');
		return;
	}

	const addToCartButton = event.target.closest('.productitem--action-trigger.productitem--action-atc.button-primary.new_atc_button');
	if (addToCartButton) {
		trackMidaEvent('product_add_to_cart_click');
		return;
	}

	const productLink = event.target.closest('.productitem a[href], .product-all-features, .product-learn-more-btn, .product-video-all-features');

	if (!productLink || productLink.closest('.product-card-swatches') || productLink.hasAttribute('data-product-card-swatch')) return;

	trackMidaEvent('product_click');
});


document.addEventListener("DOMContentLoaded", function () {
	// Smooth scroll for anchor links
	document.querySelectorAll('a[href*="#"]:not([href="#"])').forEach(anchor => {
		anchor.addEventListener("click", function (e) {
			const targetId = this.hash.slice(1);
			const target = document.getElementById(targetId);
			if (target) {
				e.preventDefault();
				const offset = target.getBoundingClientRect().top + window.pageYOffset - 90;
				window.scrollTo({ top: offset, behavior: "smooth" });
			}
		});
	});

	// Handle scroll on load if URL has a hash
	if (window.location.hash) {
		window.addEventListener("load", function () {
			const targetId = window.location.hash.slice(1);
			const target = document.getElementById(targetId);
			if (target) {
				const offset = target.getBoundingClientRect().top + window.pageYOffset - 120;
				window.scrollTo({ top: offset, behavior: "smooth" });
			}
		});
	}

	const starGroups = document.querySelectorAll(".js-animate-stars");
	if (starGroups.length) {
		const starObserver = new IntersectionObserver(
			function(entries, observer) {
				entries.forEach(function(entry) {
					if (!entry.isIntersecting) return;
					entry.target.classList.add("is-visible");
					observer.unobserve(entry.target);
				});
			},
			{
				threshold: 0.35
			}
		);

		starGroups.forEach(function(group) {
			starObserver.observe(group);
		});
	}

	const trustedByCounters = document.querySelectorAll(".js-trusted-by-counter");
	if (trustedByCounters.length) {
		const trustedByCounterObserver = new IntersectionObserver(
			function(entries, observer) {
				entries.forEach(function(entry) {
					if (!entry.isIntersecting || entry.target.classList.contains("counted")) return;

					const start = parseInt(entry.target.getAttribute("data-start"), 10);
					const end = parseInt(entry.target.getAttribute("data-end"), 10);
					const duration = parseInt(entry.target.getAttribute("data-duration"), 10) || 3000;
					const easing = entry.target.getAttribute("data-counter-easing") || "easeOutExpo";

					entry.target.classList.add("counted");
					animateCounter(entry.target, start, end, duration, easing);
					observer.unobserve(entry.target);
				});
			},
			{
				threshold: 0.35
			}
		);

		trustedByCounters.forEach(function(counter) {
			trustedByCounterObserver.observe(counter);
		});
	}
});

document.addEventListener('click', function(event) {
	const faqToggleTitle = event.target.closest('.faq-toggle .toggle-title');
	if (faqToggleTitle) {
		faqToggleTitle.classList.toggle('opened');
		const nextElement = faqToggleTitle.nextElementSibling;
		if (nextElement) {
			const isHidden = window.getComputedStyle(nextElement).display === 'none';
			nextElement.style.display = isHidden ? 'block' : 'none';
		}
		return;
	}

	const cartButton = event.target.closest('.site-header-cart-button');
	if (cartButton) {
		event.preventDefault();
		console.log('update_cart 1');
		update_cart();
		return;
	}

	const closeCartButton = event.target.closest('#cart_overlay, #close-cart-drawer');
	if (closeCartButton) {
		console.log('clicked');
		event.preventDefault();
		document.querySelectorAll('#cart_overlay, #cart_drawer').forEach(function(element) {
			element.classList.remove('open');
		});
	}
});


/*Shipping protection */



let
  cart_currency = window.Shopify.currency?.active || getCookie("cart_currency"),
  exchange_data = getCookie("exchange_data_v2"),
  exchange_rate = 1,
  exchange_currency = "";

exchange_data = exchange_data.split(':');

if ( exchange_data.length >= 2 ) {
	exchange_currency = exchange_data[0];
	exchange_rate = parseFloat(exchange_data[1]) || 1;
}

function initCartVote(cartForm, openOnLoad = true) {
	const orderVote = cartForm.querySelector('[data-vote]');
	if (!orderVote || window.Shopify.designMode) return;

	const selectedVote = orderVote.dataset.vote || '';

	if (selectedVote === 'disabled') {
		if (!openOnLoad) return;
		fetch('/cart/update.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/json'
			},
			body: JSON.stringify({
				attributes: {
					vote: ''
				}
			})
		})
		.then((response) => {
			if (!response.ok) {
				throw new Error('Failed to clear vote attribute');
			}
			return response.json();
		})
		.then(() => {
			console.log('update_cart 2');
			update_cart();
		})
		.catch((error) => {
			console.error(error);
		});

		return;
	}

	const voteModal = orderVote.querySelector('[data-vote-modal]');
	const voteWarning = orderVote.querySelector('[data-vote-warning]');
	const voteSummaryLabel = orderVote.querySelector('[data-vote-selected-label]');
	const voteEmptyMessage = orderVote.querySelector('[data-vote-empty-message]');
	const voteOpenButtons = orderVote.querySelectorAll('[data-vote-open]');
	const voteCloseButtons = orderVote.querySelectorAll('[data-vote-close]');
	const voteSelectButtons = orderVote.querySelectorAll('[data-vote-select]');
	const hasVoteSelection = selectedVote === 'nsw' || selectedVote === 'qld';

	function voteLabel(vote) {
		if (vote === 'nsw') return 'Team NSW';
		if (vote === 'qld') return 'Team QLD';
		return '';
	}

	function setSelectedCard(vote) {
		orderVote.querySelectorAll('[data-vote-select]').forEach((card) => {
			card.classList.toggle('is-selected', card.dataset.voteSelect === vote);
		});
	}

	function openVoteModal() {
		voteModal.hidden = false;
		voteWarning.hidden = true;
	}

	function closeVoteModal() {
		voteModal.hidden = true;

		if (!orderVote.dataset.vote && voteEmptyMessage) {
			voteEmptyMessage.textContent = 'Please select your Origin team to enter.';
		}
	}

	async function voteUpdateCartAttributes(vote) {
		const response = await fetch('/cart/update.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/json'
			},
			body: JSON.stringify({
				attributes: {
					vote: vote
				}
			})
		});

		if (!response.ok) {
			throw new Error('Failed to update cart attributes');
		}

		return response.json();
	}

	async function selectVote(vote) {
		try {
			await voteUpdateCartAttributes(vote);

			orderVote.dataset.vote = vote;
			setSelectedCard(vote);

			if (voteSummaryLabel) {
				voteSummaryLabel.textContent = voteLabel(vote);
			}

			closeVoteModal();
			document.dispatchEvent(new CustomEvent('vote:selected', {
				detail: { vote }
			}));

			console.log('update_cart 3');
			update_cart();
		} catch (error) {
			voteWarning.hidden = false;
			voteWarning.textContent = 'Something went wrong saving your team. Please try again.';
		}
	}

	voteOpenButtons.forEach((button) => {
		button.addEventListener('click', openVoteModal);
	});

	voteCloseButtons.forEach((button) => {
		button.addEventListener('click', closeVoteModal);
	});

	voteSelectButtons.forEach((button) => {
		button.addEventListener('click', () => {
			selectVote(button.dataset.voteSelect);
		});
	});

	if (!hasVoteSelection && openOnLoad) {
		openVoteModal();
	} else {
		setSelectedCard(orderVote.dataset.vote);
	}
}

let cartSectionId = document.querySelector('#cart_page_form [data-cart-form]')?.dataset.sectionId || '';
let cartNoteSave = Promise.resolve(true);

async function fetchCartForm() {
	await cartNoteSave;
	const url = new URL(window.Shopify.routes.root + 'cart', window.location.origin);
	// The template instance holds the merchant's block order. Discover it once, then use section rendering.
	if (cartSectionId) url.searchParams.set('section_id', cartSectionId);
	const response = await fetch(url);
	if (!response.ok) throw new Error('Unable to load cart');
	const html = await response.text();
	const cartHTML = new DOMParser().parseFromString(html, 'text/html');
	const form = cartHTML.querySelector('[data-cart-form]');
	if (!form) throw new Error('Cart section did not return a cart form');
	cartSectionId = form.dataset.sectionId;
	return form;
}

function load_new_cart() {
	return fetchCartForm().then((cart_form) => {
		const cartPage = document.getElementById('cart_page_form');
		if (cartPage) {
			const pageForm = cart_form.cloneNode(true);
			cartPage.replaceChildren(pageForm);
			initCartContent(pageForm, false);
			initCartVote(pageForm, false);
		}
		document.getElementById('cart-drawer-contents').replaceChildren(cart_form);
		const headerCartCount = document.querySelector('.site-header-cart--count');
		const visibleCartCount = parseInt(cart_form.dataset.visibleCartCount || '0', 10);
		if (headerCartCount) {
			if (visibleCartCount > 0) headerCartCount.dataset.headerCartCount = visibleCartCount;
			else headerCartCount.removeAttribute('data-header-cart-count');
			headerCartCount.classList.toggle('visible', visibleCartCount > 0);
		}
		initCartVote(cart_form);
		initCartContent(cart_form);
		document.dispatchEvent(new CustomEvent('cart:rerendered'));
		document.querySelectorAll('#cart_overlay, #cart_drawer').forEach(element => element.classList.add('open'));
	}).catch(error => console.error(error));
}

function initCartContent(cart_form, runCartRules = !window.Shopify.designMode) {
	// Prefer Shopify's current rate; only use a cached rate for the active currency.
	const cartExchangeRate = Number(window.Shopify.currency?.rate) || (exchange_currency === cart_currency ? exchange_rate : 1);
	const bundleSelect = cart_form.querySelector('.cart-bundle-products > .form-field-select-wrapper .cart-bundle-options');
	if (bundleSelect?.value) bundleChange({target: bundleSelect});
	const
		progress_header = cart_form.querySelector('.goal-progress-header'),
		progress_bar = cart_form.querySelector('.bar');

	let progress_goals = Array.from(cart_form.querySelectorAll('.goal[data-goal]')).map((goal) => ({
		element: goal,
		threshold: parseInt(goal.dataset.threshold || '0', 10),
		type: goal.dataset.goalType || 'product',
		title: goal.dataset.title || '',
		message: goal.dataset.message || '',
		label: goal.textContent.trim()
	}));

	let
		cart_price = parseInt(cart_form.dataset.cartPrice || '0', 10),
		next_goal = '',
		next_threshold = 0,
		goal_prefix = 'a FREE ';

	progress_goals = progress_goals.map((goal) => ({
		...goal,
		threshold: goal.threshold * cartExchangeRate
	}));

	const unlockedGoals = progress_goals.filter((goal) => goal.threshold !== 0 && cart_price >= goal.threshold);
	const nextGoalData = progress_goals.find((goal) => goal.threshold !== 0 && cart_price < goal.threshold);

	if (nextGoalData) {
		next_threshold = nextGoalData.threshold;
		next_goal = nextGoalData.type === 'message'
			? nextGoalData.message
			: (nextGoalData.title || nextGoalData.label);

		if (nextGoalData.type === 'message') {
			goal_prefix = '';
		}
	}

	if (progress_header && progress_bar) {
	progress_header.replaceChildren();
	const paragraph = document.createElement('p');
	if (progress_goals.length && unlockedGoals.length === progress_goals.length) {
		paragraph.innerHTML = 'Congrats, you have unlocked all free gifts!';
		//paragraph.innerHTML = 'Congrats, you have unlocked 3 caravan entries!';
	} else if (next_goal !== '') {
		const next_value = (next_threshold - cart_price) / 100.00;
		paragraph.innerHTML = `You are <b>$<span data-money-convertible>${ next_value.toFixed(2) }</span></b> away from ${goal_prefix} <b>${next_goal.split(' - ')[0]}</b>`;
	} else if (unlockedGoals.length) {
		const lastUnlockedGoal = unlockedGoals[unlockedGoals.length - 1];
		const unlockedLabel = lastUnlockedGoal.type === 'message'
			? lastUnlockedGoal.message
			: (lastUnlockedGoal.title || lastUnlockedGoal.label);
		paragraph.innerHTML = `Congrats, you have unlocked <strong>${unlockedLabel}</strong>`;
	}

	if (paragraph.innerHTML !== '') {
		progress_header.appendChild(paragraph);
	}

	const maxGoal = progress_goals.length ? progress_goals[progress_goals.length - 1].threshold : 0;
	const goalPercent = maxGoal ? Math.min((cart_price * 100) / maxGoal, 100) : 0;

	progress_bar.style.width = `${goalPercent}%`;
	progress_goals.forEach((goal) => {
		const goalPosition = maxGoal ? (goal.threshold * 100) / maxGoal : 0;
		goal.element.style.right = `${100 - goalPosition}%`;
	});

	}

	//Show Free Gifts
	let free_gifts_to_add = [];
	const items = cart_form.querySelectorAll('.free-gift');

	for (var i = 0; i < items.length; i++) {
		const item = items.item(i);
		let threshold = parseInt(item.dataset.threshold);

		threshold = threshold * cartExchangeRate;

		if ( threshold <= cart_price && threshold != 0 ) {
			item.style.display = 'block';

			//Auto add free gifts to cart in single variants
			const item_select = item.querySelector('.auto-gwp');
			if (runCartRules && item_select?.value) {
				free_gifts_to_add.push(item_select.value)
			}
		}
	}


	const protection = cart_form.querySelector('.shipping-protection');
	if (runCartRules && protection?.dataset.variantId && !protection.dataset.cartKey && getCookie('shipping_protection') !== 'false') {
		free_gifts_to_add.push(protection.dataset.variantId);
	}

		//console.log( free_gifts_to_add )
		console.log('free_gifts_to_add',free_gifts_to_add)
		if (free_gifts_to_add.length) {
			const giftItems = free_gifts_to_add.map((id) => ({
				id,
				quantity: 1
			}));

			addToCart(giftItems).then(({ status }) => {
				switch (status) {
					case 400:
						console.log('no product available');
						break;
					case 201:
					case 200:
						console.log('completed - success')
						console.log('update_cart 4');
						update_cart();
						break;
					case 500:
						break;
					default:
					//Any default tasks
				}
			});
		}

	if (!runCartRules) return;

	const bxgyRules = parseJsonAttribute(cart_form, 'data-bxgy-rules');
	const bxgyCartLines = parseJsonAttribute(cart_form, 'data-bxgy-cart-lines');

	//console.log('bxgyRules',bxgyRules)
	//console.log('bxgyCartLines',bxgyCartLines)

	for (const rule of bxgyRules) {
		if (rule.getTriggerType !== 'product' || !rule.autoAddGetProduct) {
			continue;
		}

		const triggerQty = getBxgyMatchedQuantity(bxgyCartLines, rule, 'buy');
		const getMatch = getBxgyProductMatch(bxgyCartLines, rule);
		const getQty = getMatch ? getMatch.quantity : 0;
		const getKey = getMatch ? getMatch.key : '';
		const getVariantId = normalizeShopifyNumericId(rule.getProductVariantId);

		if (triggerQty !== getQty) {
			//console.log('has qty',triggerQty)

			if (getQty === 0) {
				//console.log('getQty',getQty)
				//console.log('lets add a:',getVariantId)

				if (getVariantId) {
					//console.log('lets add b:',getVariantId)
					addProductToCart(getVariantId);
					break;
				}
			} else if (triggerQty !== 0 && getKey) {
				//Match get quantity to trigger quantity
				updateCartLine(getKey, triggerQty);
				break;
			}
		}
	}

}

function initCartSection(root) {
	const form = root.querySelector('#cart_page_form [data-cart-form]');
	if (!form) return;
	cartSectionId = form.dataset.sectionId;
	initCartContent(form, false);
	if (!window.Shopify.designMode) initCartVote(form);
}

document.addEventListener('DOMContentLoaded', () => initCartSection(document));
document.addEventListener('shopify:section:load', event => initCartSection(event.target));

function saveCartNote(input) {
	const note = input.value;
	const errorMessage = input.closest('.cart-ordernote').querySelector('[data-cart-note-error]');
	cartNoteSave = cartNoteSave.then(async () => {
		if (input.defaultValue === note) return true;
		try {
			const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
				method: 'POST',
				headers: {'Content-Type': 'application/json'},
				body: JSON.stringify({note})
			});
			if (!response.ok) throw new Error('Unable to save order note');
			input.defaultValue = note;
			errorMessage.hidden = true;
			return true;
		} catch (error) {
			errorMessage.textContent = 'Your order note could not be saved. Please try again.';
			errorMessage.hidden = false;
			return false;
		}
	});
	return cartNoteSave;
}

document.addEventListener('change', event => {
	if (event.target.matches('[data-cart-note]')) saveCartNote(event.target);
});

document.addEventListener('click', async event => {
	const checkout = event.target.closest('.cart-checkout a');
	const note = checkout?.closest('[data-cart-form]')?.querySelector('[data-cart-note]');
	if (!note) return;
	event.preventDefault();
	if (await saveCartNote(note)) window.location.assign(checkout.href);
});

function parseJsonAttribute(element, attributeName) {
	const value = element.getAttribute(attributeName);
	if (!value) {
		return [];
	}

	try {
		return JSON.parse(value);
	} catch (error) {
		console.error(`Failed to parse ${attributeName}`, error);
		return [];
	}
}

function normalizeShopifyNumericId(value) {
	if (!value) {
		return 0;
	}

	if (typeof value === 'number') {
		return Number.isFinite(value) ? value : 0;
	}

	const stringValue = String(value).trim();
	if (!stringValue) {
		return 0;
	}

	const match = stringValue.match(/(\d+)$/);
	if (!match) {
		return 0;
	}

	return parseInt(match[1], 10);
}

function getBxgyMatchedQuantity(cartLines, rule, side) {
	const triggerType = rule[`${side}TriggerType`];
	const tagValue = String(rule[`${side}Tag`] || '').toLowerCase();
	const typeValues = Array.isArray(rule[`${side}Types`]) ? rule[`${side}Types`] : [];

	return cartLines.reduce((total, line) => {
		const lineTags = Array.isArray(line.tags) ? line.tags.map((tag) => String(tag).toLowerCase()) : [];
		const lineType = line.productType || '';

		if (triggerType === 'type' && typeValues.includes(lineType)) {
			return total + Number(line.quantity || 0);
		}

		if (triggerType === 'tag' && tagValue && lineTags.includes(tagValue)) {
			return total + Number(line.quantity || 0);
		}

		return total;
	}, 0);
}

function getBxgyProductMatch(cartLines, rule) {
	return cartLines.find((line) => line.productHandle === rule.getProductHandle) || null;
}

function updateCartLine(key,qty){

	console.log('updateCartLine')
	const cartItem = document.querySelector(`[data-cartitem-id="${CSS.escape(key)}"]`);
	if (cartItem) {
		cartItem.classList.add('is-updating');
	}

	let updates = {
		'id': key,
		'quantity': qty
	}

	fetch(window.Shopify.routes.root + 'cart/change.js', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(updates)
	})
	.then(response => {
		return response.json();
	})
	.then(cart_data => {
		console.log('update_cart 5');
		update_cart();
	})
	.catch(error => {});
}


function update_cart() {
	console.log('updating cart');

	const shopifyRate = Number(window.Shopify.currency?.rate);
	if (shopifyRate) {
		exchange_rate = shopifyRate;
		exchange_currency = cart_currency;
		load_new_cart();
		return;
	}

	// Legacy cookie/product-price lookup is only needed when Shopify's rate is unavailable.
	if ( cart_currency != 'AUD' && cart_currency != 'CAD' && cart_currency != 'USD' ){
		const needs_exchange_refresh =
			!exchange_currency ||
			exchange_currency != cart_currency ||
			!exchange_rate ||
			exchange_rate <= 0 ||
			exchange_rate === 1;

		if ( needs_exchange_refresh ) {

			const local_price = parseFloat(document.getElementById('exchange-rate').innerHTML);

				const exchangeProductUrl = new URL('/products/hammock-river-blue', window.location.origin);
				exchangeProductUrl.searchParams.set('country', 'AU');

				fetch(exchangeProductUrl.toString())
			.then(response => response.text())
			.then(html => {
				//console.log( html )
				var parser = new DOMParser();
				var pageHTML = parser.parseFromString(html, 'text/html');

				const au_price = parseFloat(pageHTML.getElementById('exchange-rate').innerHTML);

				console.log('au_price',au_price)
				exchange_rate = local_price / au_price
				exchange_currency = cart_currency;

				if ( cart_currency == 'USD' ) {
					exchange_rate = 0.68
				}

				setCookie('exchange_data_v2', cart_currency+':'+exchange_rate, 0.1);
				load_new_cart();
			})
			.catch(e => {
				console.error(e);
			});
		} else {
      load_new_cart();
    }

		/*
		var myHeaders = new Headers();
		myHeaders.append("apikey", "lOsnayIzvLKn5KnpROXzFKRML2g1YKGI");

		var requestOptions = {
		method: 'GET',
		redirect: 'follow',
		headers: myHeaders
		};

		fetch("https://api.apilayer.com/exchangerates_data/latest?symbols=CAD,DKK,EUR,AED,JPY,NZD,NOK,SGD,ZAR,SEK,CHF,GBP,USD&base=AUD", requestOptions)
		.then(response => response.text())
		.then(text => {
		const json = JSON.parse(text);
		console.log(json);
		setCookie('exchange_rate', JSON.stringify(json.rates), 0.1);
		exchange_rate = json.rates;

		load_new_cart();
		})
		.catch(error => console.log('error', error));
		*/
	} else {
		//console.log( exchange_data )
		load_new_cart();
	}
}

function addToCart(items) {
	return fetch('/cart/add.js', {
		method: 'POST',
		credentials: 'same-origin',
		headers: {
			'Content-Type': 'application/json',
			'X-Requested-With': 'XMLHttpRequest'
		},
		body: JSON.stringify({
			items: items.map((item) => ({
				...item,
				quantity: Number(item.quantity) || 1
			}))
		})
	}).then(async(response) => {
		let json = null;

		try {
			json = await response.json();
		} catch (error) {
			console.error('cart add response parse failed', error);
		}

		return {
			status: response.status,
			ok: response.ok,
			json
		};
	});
}

document.addEventListener('click', (event) => {
	const addGiftButton = event.target.closest('[data-cart-form] .add-gift');

	if (addGiftButton) {
		const form = addGiftButton.closest('.free-gift-form');
		const variantSelect = form ? form.querySelector('select') : null;
		const variant_id = variantSelect ? variantSelect.value : '';

		addGiftButton.textContent = 'adding...';

		const product_data = {
			quantity: 1,
			id: variant_id
		};

		addToCart([product_data]).then(({ status, json }) => {
			switch (status) {
				case 400:
					console.log('no product available');
					break;
				case 201:
					break;
				case 200:
					console.log('product added');
					console.log(json);
					console.log('update_cart 6');
					update_cart();
					addGiftButton.textContent = 'Add';
					break;
				case 500:
					break;
				default:
			}
		});

		return;
	}

	const variantItem = event.target.closest('#cart_drawer .variant-item');

	if (!variantItem) return;

    let variants = document.querySelectorAll('.variant-item');

    variants.forEach(e => {
        e.classList.remove('active')
    })


    let target = event.target;
    let img = target.querySelector('img')
    if (img == null) {
        img = target;
        event.target.parentElement.classList.add('active')
    }
    else {
        event.target.classList.add('active')
    }

    //console.log('src', img.src)
    let main_img = document.querySelector('#cart-drawer-contents .upsell_image img');
    main_img.src = img.src;

    let new_target = event.target.parentElement;

    //origin price
    let origin = new_target.dataset.variantOrigin;
    if (origin == null) origin = event.target.dataset.variantOrigin;
    let main_original = document.querySelector('#cart-drawer-contents .new_upsell_item .price--compare-at');
    if (main_original != null) main_original.innerHTML = origin;


    //final price
    let final = new_target.dataset.variantPrice;
    if (final == null) final = event.target.dataset.variantPrice;
    let main_price = document.querySelector('#cart-drawer-contents .new_upsell_item .price--main');
    main_price.innerHTML = `Just ${final}`;


    //color name
    let color = new_target.dataset.variantTitle;
    if (color == null) color = event.target.dataset.variantTitle;
    let main_title = document.querySelector('#cart-drawer-contents .new_upsell_item .product-variant .value');
    main_title.innerHTML = color;


    // fetch(url).then(e => e.text()).then(html => {
    //   const div = document.createElement('div');
    //   div.innerHTML = html;
    //   document.querySelector('.product--price').innerHTML = div.querySelector('.product--price').innerHTML;
    //   let button = div.querySelector('.gallery-navigation--scroller button[data-gallery-selected="true"]');
    //   console.log('button', button);
    //   div.remove();
    // })

});

document.addEventListener('change', (event) => {
	const quantityInput = event.target.closest('.cart-item [data-cartitem-quantity]');

	if (!quantityInput) return;

	const cart_item_qty = Math.max(1, parseInt(quantityInput.value, 10) || 1);
	const cart_item_id = quantityInput.closest('.cart-item')?.dataset.cartitemId;
	quantityInput.value = cart_item_qty;

	console.log('change id:'+cart_item_id)
	console.log('cart_item_qty:'+cart_item_qty)
	updateCartLine(cart_item_id,cart_item_qty)
});

document.addEventListener('click', (event) => {
	const quantityButton = event.target.closest('[data-cartitem-quantity-change]');

	if (!quantityButton) return;

	const cartItem = quantityButton.closest('.cart-item');
	const quantityInput = cartItem?.querySelector('[data-cartitem-quantity]');
	if (!quantityInput) return;

	const currentQuantity = Math.max(1, parseInt(quantityInput.value, 10) || 1);
	const nextQuantity = Math.max(0, currentQuantity + Number(quantityButton.dataset.cartitemQuantityChange));
	if (nextQuantity === currentQuantity) return;

	quantityInput.value = nextQuantity;
	updateCartLine(cartItem.dataset.cartitemId, nextQuantity);
});

document.addEventListener('click', (event) => {
	const removeLink = event.target.closest('.cart-item--remove-link');

	if (!removeLink) return;

  event.preventDefault();

  const cart_item_id = removeLink.closest('.cart-item')?.dataset.cartitemId;

	console.log('change id:'+cart_item_id)
	console.log('cart_item_qty:'+0)
	//console.log( 'remove: '+ cart_item_id)
	updateCartLine(cart_item_id,0)

	/*
  $.ajax({
      url: '/cart/change?line='+cart_item_id+'&quantity=0',
      dataType: 'json',
      type: 'post',
      success: function (cart) {
        //console.log(cart)
        update_cart()
      },
      error: function (XMLHttpRequest) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
        console.log("Error: " + response);
      }
  }).done(function () {
      //any done functions?
  });*/
});

document.addEventListener('click', (event) => {
	// Product Grid Quick Add
	const addToCartButton = event.target.closest('.new_atc_button');

	if (!addToCartButton) return;

  event.preventDefault();
  const variantInput = addToCartButton.previousElementSibling;
  let variant_id = variantInput ? variantInput.value : '';

  //this_btn.text('Adding...')
  const product_data = {
      quantity: 1,
      id: variant_id
  };

	if (variantInput?.dataset.preorder === 'true') {
		product_data.properties = {
			Preorder: getPreorderPropertyValue(variantInput)
		};
	}

  addToCart([product_data]).then(({ status, json }) => {
    switch (status) {
      case 400:
        console.log('no product available');
        break;
      case 201:
          break;
      case 200:
          console.log(json);
          update_cart();
          //this_btn.text('Add')

          break;
      case 500:
          break;
      default:
      //Any default tasks
    }
  });
});

/* removed Jan 2025
$('.product-selector-wrapper').on("click", ".option-value-label", function() {
	const form_options = $(this).closest('.form-options');
	form_options.find('.option-value').removeClass('option-selected');
	$(this).closest('.option-value').addClass('option-selected');
});

$('.product-form--regular').on("click", ".option-value-label", function() {
	const form_options = $(this).closest('.form-options');
	form_options.find('.option-value').removeClass('option-selected');
	$(this).closest('.option-value').addClass('option-selected');
});*/

function addProductToCart(select_variant,form_properties){
	const quantityEl = document.getElementById('product-quantity-input');
	let quantity_value = 1

	if (quantityEl) {
		quantity_value = quantityEl.value
	}

	let product_data = {
		quantity: quantity_value,
		id: select_variant
	}
	//console.log('atc form:')
	//console.log(form_properties);
	if (form_properties && form_properties != {} ) {
		product_data = {
			quantity: quantity_value,
			id: select_variant,
			properties: form_properties
		}
	}

	//include selling plans
	const sp = new URLSearchParams(window.location.search).get('selling_plan');
	if (sp && /^\d+$/.test(sp)) {
		// Shopify expects the numeric selling plan ID
		product_data.selling_plan = Number(sp);
	}

	console.log(product_data);

	addToCart([product_data]).then(({ status, json, ok }) => {
		switch (status) {
			case 400:
				console.log('no product available');
				break;
			case 201:
				break;
			case 200:
				document.documentElement.dispatchEvent(new CustomEvent('product:added', {
						bubbles: true,
						detail: {
							variant: select_variant,
							quantity: quantity_value
						}
					}));
				console.log('update_cart 8');
				update_cart();
				break;
			case 500:
					break;
			default:
			//Any default tasks
		}
	})
}

function setAtcButtonLoading(button, loadingLabel = 'Adding To Cart') {
	if (!button) return;

	button.disabled = true;

	const buttonText = button.querySelector('.atc-button--text');
	if (buttonText) {
		if (!button.dataset.defaultLabel) {
			button.dataset.defaultLabel = buttonText.textContent.trim();
		}
		buttonText.textContent = loadingLabel;
		button.classList.add('processing');
		return;
	}

	if (!button.dataset.defaultLabel) {
		button.dataset.defaultLabel = button.textContent.trim();
	}
	button.textContent = loadingLabel;
}

function resetAtcButtonLoading(button) {
	if (!button) return;

	button.disabled = false;

	const buttonText = button.querySelector('.atc-button--text');
	if (buttonText) {
		button.classList.remove('processing');
		if (button.dataset.defaultLabel) {
			buttonText.textContent = button.dataset.defaultLabel;
		}
		return;
	}

	if (button.dataset.defaultLabel) {
		button.textContent = button.dataset.defaultLabel;
	}
}

function getProductActionScope(triggerElement) {
	return triggerElement?.closest('.featured-product--container, .product--outer, .product-main, .product-form--regular') || document;
}

function addProductsToCart(selected_variants,button){
	console.log( selected_variants )
	addToCart(selected_variants).then(({ status }) => {
		switch (status) {
			case 400:
				console.log('no product available');
				break;
			case 201:
			case 200:
				console.log('completed - success')
				console.log('update_cart 9');
				update_cart();
				break;
			case 500:
				break;
			default:
			//Any default tasks
		}
	}).finally(() => {
		resetAtcButtonLoading(button);
	});
}


/* == Couples Combo Bundle == */

/* Update Button Status for preorder */

(() => {
	const BUNDLE_SELECTOR = '.option-values.type-bundle';
	const INPUT_SELECTOR  = '.option-value-input';
	const LABEL_SELECTOR  = '.option-value-label';

	const preorderText = document.querySelector('.preorder-message');

	function updateButtonText() {
		const btnEl = document.querySelector('#add-bundle .atc-button--text, #add-custom-bundle .atc-button--text');
		if (!btnEl) return;

		let anyPreorder = false;
		document.querySelectorAll(BUNDLE_SELECTOR).forEach(bundle => {
			const checked = bundle.querySelectorAll(`${INPUT_SELECTOR}:checked`);
			for (const input of checked) {
				const raw = (input.getAttribute('data-atc_btn') || '');
				const v = raw.trim().toLowerCase().replace(/\s+/g, ''); // normalize
				if (v === 'pre-order' || v === 'preorder') {
					anyPreorder = true;
					break;
				}
			}
		});

		if (anyPreorder) {
			btnEl.textContent = 'Pre-Order';
			preorderText.style.display = 'block';
		} else {
			btnEl.textContent = 'Add To Cart';
			preorderText.style.display = 'none';
		}
	}

	// Run on page load
	document.addEventListener('DOMContentLoaded', updateButtonText);

	// Respond to input changes inside bundles
	document.addEventListener('change', (e) => {
		if (e.target.matches(INPUT_SELECTOR) && e.target.closest(BUNDLE_SELECTOR)) {
			updateButtonText();
		}
	});
})();

/* Add To Cart */
document.getElementById('add-bundle')?.addEventListener('click', function(e){
	// For product page bundle combos
	const button = this;
	const scope = getProductActionScope(button);
	let selected_variants = [];
	const sizeInput = scope.querySelector('#product-quantity-select')?.selectedOptions[0];

	scope.querySelectorAll('.form-options').forEach((formOption) => {
		const selectedInput = formOption.querySelector('.option-value-input:checked');
		const selected_variant = {
			quantity: sizeInput?.value || 1,
			id: selectedInput ? selectedInput.dataset.id : ''
		};

		if (selectedInput?.dataset.preorder === 'true') {
			selected_variant.properties = {
				Preorder: getPreorderPropertyValue(selectedInput)
			};
		}

		selected_variants.push(selected_variant)
	});

	/*Include any upsell items */
	const upsellInputs = scope.querySelectorAll('.product-upsell input');
	upsellInputs.forEach(input => {
		if (input.checked) {
			const selected_variant = {
				quantity: input.dataset.qty,
				id: input.value
			}

			if (input.dataset.preorder === 'true') {
				selected_variant.properties = {
					Preorder: getPreorderPropertyValue(input)
				};
			}

			selected_variants.push(selected_variant);
		}
	});

	button.disabled = true;
	setAtcButtonLoading(button);

	addProductsToCart(selected_variants,button)
});

document.getElementById('add-custom-bundle')?.addEventListener('click', function(e){
	const button = this;
	const scope = getProductActionScope(button);
	let selected_variants = [];
	let bundle_price = 0;
	const sizeInput = scope.querySelector('#product-quantity-select')?.selectedOptions[0];

	scope.querySelectorAll('.form-options').forEach((formOption) => {
		const selected_option = formOption.querySelector('.option-value-input:checked');
		const selected_variant = {
			quantity: sizeInput?.value || 1,
			id: selected_option ? selected_option.dataset.id : ''
		};

		if (selected_option?.dataset.preorder === 'true') {
			selected_variant.properties = {
				Preorder: getPreorderPropertyValue(selected_option)
			};
		}

		selected_variants.push(selected_variant)
		bundle_price = bundle_price + parseInt(selected_option?.dataset.price || 0, 10);
	});

	button.disabled = true;
	setAtcButtonLoading(button);

	addProductsToCart(selected_variants,button)

	bundle_price = (bundle_price * 0.8) / 100;
	//console.log( bundle_price );
	ga_event('add_bundle','Bundle Builder',bundle_price)
});

document.getElementById('add-single-product')?.addEventListener('click', function(e){
	e.preventDefault();
	const scope = getProductActionScope(this);
	let variant_id = '';

	scope.querySelectorAll('.form-options').forEach((formOption) => {
		const selectedInput = formOption.querySelector('.option-value-input:checked');
		variant_id = selectedInput ? selectedInput.dataset.id : variant_id;
	});

	console.log('adding: '+variant_id);

	addProductToCart(variant_id);
});

let AddToCartBtn = document.getElementById('AddToCart');
const AddToCartSticky = document.getElementById('sticky-add-to-cart');
if (AddToCartBtn && AddToCartSticky) {
	const position = AddToCartBtn.getBoundingClientRect();
	window.addEventListener('scroll', () => {
		let st = window.scrollY;
		if (st > position.top){
			AddToCartSticky.classList.add('stick')
		} else {
			AddToCartSticky.classList.remove('stick')
		}
	});
}

//Bundle Builder
const add_btn = document.querySelector(".js-add-more");
const selector_container = document.querySelector('.product-selector-wrapper')

//ADD MORE SELECTOR
add_btn?.addEventListener('click',()=>{

  const div = document.createElement("div");
  div.innerHTML = selector_container.innerHTML;
  const new_selector = div.querySelector('.product-selector');
  const product_number = selector_container.childElementCount + 1;

	let option_values = new_selector.querySelectorAll('.option-value');

	//console.log( option_values )
	for (const option of option_values) {

		const new_label = option.querySelector('.option-value-label')
		const new_input = option.querySelector('.option-value-input')
		const new_attr = new_label.getAttribute('for').replace('product-1','product-'+product_number);

		new_label.setAttribute('for',new_attr)
		new_input.setAttribute('id',new_attr)
		new_input.setAttribute('name','product-'+product_number)
	}

  new_selector.querySelector('.selector-heading .number').innerHTML = product_number;

  new_selector.querySelector('.control-products').classList.remove('swiper-1');
  new_selector.querySelector('.control-products').classList.add('swiper-'+product_number);

	new_selector.querySelector('.swiper-button-prev').classList.remove('swiper-prev-1');
    new_selector.querySelector('.swiper-button-prev').classList.add('swiper-prev-'+product_number);
    new_selector.querySelector('.swiper-button-next').classList.remove('swiper-next-1');
    new_selector.querySelector('.swiper-button-next').classList.add('swiper-next-'+product_number)

	selector_container.appendChild(new_selector)

	var swiper_new = new Swiper('.swiper-'+product_number, {
		spaceBetween: 3,
		slidesPerView: 3.5,
		breakpoints: {
			990: {
				slidesPerView: 4.5,
			}
		},
		pagination: {
			clickable: true,
		},
		navigation: {
			nextEl: '.swiper-next-'+product_number,
			prevEl: '.swiper-prev-'+product_number,
		},
		init: false
	});
	swiper_new.on('beforeInit', function () {
	    swiper_new.slideTo(1, 1, false)
	    swiper_new.slidePrev(1, false)
	})
	swiper_new.init()

})

function bundleChange(e){
	const bundle = e.target.closest('.cart-bundle-upsell');
	const bundleOptionsObjects = bundle.querySelectorAll('.cart-option-products');

	bundleOptionsObjects.forEach((object) => {
		object.style.display = 'none';
		object.classList.remove('selected');
	});

	const cartOptionProductElement = bundle.querySelector('.cart-option-products[data="'+e.target.value+'"]');
	if (cartOptionProductElement) {
		cartOptionProductElement.style.display = 'block';
		cartOptionProductElement.classList.add('selected');
	}

	const bundleOptionsPriceObjects = bundle.querySelectorAll('.cart-option-prices');
	bundleOptionsPriceObjects.forEach((object) => {
		object.style.display = 'none';
	});
	const cartOptionPriceElement = bundle.querySelector('.cart-option-prices[data="'+e.target.value+'"]');
	if (cartOptionPriceElement) {
		cartOptionPriceElement.style.display = 'flex';
		bundle.querySelector('#cart-upsell-percent').textContent = cartOptionPriceElement.dataset.percent;
	}

	updateCartUpsellState(bundle);

}

function bundleImageChange(e){
	updateCartUpsellState(e.target.closest('.cart-bundle-upsell'));
}

function updateCartUpsellState(bundle) {
	const selectedOption = bundle.querySelector('.cart-option-products.selected select')?.selectedOptions[0];
	const addCartUpsellButton = bundle.querySelector('#add-cart-upsell');
	const preorderMessage = bundle.querySelector('.cart-upsell-preorder-message');
	if (!addCartUpsellButton) return;
	addCartUpsellButton.disabled = !selectedOption || selectedOption.disabled;
	if (selectedOption?.dataset.src) bundle.querySelector('.new-bundle-img img').src = selectedOption.dataset.src;
	const isPreorder = selectedOption?.dataset.preorder === 'true';
	const preorderMessageText = getPreorderDisplayMessage(selectedOption);

	addCartUpsellButton.textContent = isPreorder ? 'PRE-ORDER' : 'ADD TO CART';

	if (preorderMessage) {
		preorderMessage.textContent = preorderMessageText;
		preorderMessage.hidden = !isPreorder;
		preorderMessage.style.display = isPreorder ? 'inline-block' : 'none';
	}
}

document.addEventListener('click', (event) => {
	// Cart Upsell Add
	const button = event.target.closest('#add-cart-upsell');

	if (!button) return;

	button.disabled = true;
	setAtcButtonLoading(button, 'Adding Bundle');

	const cartBundleUpsell = button.closest('.cart-bundle-upsell');

	/*
  let selected_variants = [];

	selected_variant = {
		quantity: 1,
		id: $('.cart-bundle-upsell').data('id')
	}
	selected_variants.push(selected_variant)
	*/

	const selected_upsell = cartBundleUpsell.querySelector('.cart-option-products.selected select');

	/*
	selected_variant = {
		quantity: 1,
		id: selected_upsell.value
	}
	selected_variants.push(selected_variant)
	*/

	let bundle_price = Number(cartBundleUpsell?.dataset.price || 0);
	const selectedOption = selected_upsell ? selected_upsell.selectedOptions[0] : null;
	bundle_price = bundle_price + parseInt(selectedOption?.dataset.price || 0, 10);
	bundle_price = (bundle_price * 0.8) / 100;
	ga_event('add_bundle','Bundle Upsell',bundle_price)

	let upsellProperties = null;
	const isPreorder = selectedOption?.dataset.preorder === 'true';
	if (isPreorder) {
		upsellProperties = {
			Preorder: getPreorderPropertyValue(selectedOption)
		};
	}

	addProductToCart(selected_upsell.value, upsellProperties);

	/*
	addProductsToCart(selected_variants,button)

    fetch('/cart/clear.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        },
    }).then((response) => {
      return new Promise((resolve) => response.json()
      .then((json) => resolve({
        status: response.status,
        ok: response.ok,
        json,
      })));
    }).then(({ status, json, ok }) => {
			//console.log( status )
			//console.log( json )
			//console.log('success');
			addProductsToCart(selected_variants,button)
    })
		*/
})

function ga_event(event,action,value){
	gtag('event', event, {'action': action,'value': value});
}

// Select popup wrappers without the "no-close" class
const popupWrappers = document.querySelectorAll('.popup-wrapper:not(.no-close)');

function close_popup(wrapper){
	wrapper.style.display = 'none';

	// Pause any videos within the wrapper
	const videoElements = wrapper.querySelectorAll('video');
	videoElements.forEach(video => {
		if (!video.paused) {
			video.pause();
		}
	});
}

// Handle clicks on popup wrappers
popupWrappers.forEach(wrapper => {
	wrapper.addEventListener('click', (e) => {
		if (e.target === wrapper) {  // Check for direct click on the wrapper
			e.preventDefault();
			close_popup(wrapper)
		}
	});
});

// Handle clicks on close buttons
const closeButtons = document.querySelectorAll('.close-popup');
closeButtons.forEach(button => {
	button.addEventListener('click', (e) => {
		e.preventDefault();
		const wrapper = button.closest('.popup-wrapper');
		if (wrapper) {
			close_popup(wrapper)
		}
	});
});

function handleVideoClick() {
  const prodVidContainers = document.querySelectorAll('.video-preview-wrap');
  const videoPopupMedia = document.getElementById('video-popup-media');
  const videoPopup = document.getElementById('video-popup');

  prodVidContainers.forEach(container => {
    container.addEventListener('click', () => {
      const videoSrc = container.dataset.src;
      if (videoSrc) {
        videoPopupMedia.querySelector('source').src = videoSrc;

        videoPopup.style.display = 'block';
        videoPopup.addEventListener('transitionend', () => {
	        videoPopup.style.opacity = 1;
        });

        videoPopupMedia.load();  // Trigger loading of the new video
        videoPopupMedia.play();  // Optionally start playback
		videoPopupMedia.muted = false;

      }
    });
  });
}

// Call the function to set up event listeners
handleVideoClick();

const promoTabBtn = document.querySelector('.promo-tab-btn');

if (promoTabBtn) {
	if ( getCookie("promo_popup_seen") != 'true' ) {
		setTimeout(function () {
			console.log('not-seen')
			promoTabBtn.classList.add('active');
		}, 5000);
	}

	promoTabBtn.addEventListener('click', (e) => {
		e.preventDefault();

		promoTabBtn.classList.remove('active');

		setTimeout(function () {
			const promoTabPop = document.getElementById('promo-tab-popup');
			if (promoTabPop) {
				promoTabPop.style.display = 'block';
			}
		}, 300);

		setCookie('promo_popup_seen', 'true', 0.1);
	});
}

/*
const regionSelects = document.querySelectorAll('.region-select');
regionSelects.forEach(select => {
	select.addEventListener('change', () => {
		const selectedOption = select.options[select.selectedIndex];
		const url = selectedOption.dataset.url;
		if ( url != current_region ) {
			//console.log( 'https://www.nakie.' + url + pathname.split('?')[0] + '?region='+ url );
			setCookie('geo_location4', url, 365);
			window.top.location.href = 'https://www.nakie.' + url + pathname.split('?')[0] + '?region='+ url
		}
	});
});
*/


(function() {
	var form   = document.getElementById('MarketSwitcherForm');
	var select = document.getElementById('MarketSelect');
	var countryInput = document.getElementById('CountryCodeInput');
	if (!form || !select || !countryInput) return;

	// 1) Optional: if your <option> has data-country="AU" etc., we will use that first.
	//    (Recommend adding this to each option to avoid any guessing.)
	function fromDataAttr(optionEl) {
		var v = optionEl && optionEl.dataset ? optionEl.dataset.country : null;
		return v && /^[A-Z]{2}$/.test(v) ? v : null;
	}

	// 2) Fallback: known mapping from your market handles -> ISO country code
	//    (Based on your market_list handles)
	var HANDLE_TO_COUNTRY = {
		au: 'AU',
		ca: 'CA',
		de: 'DE',   // Europe/Germany both used "de" handle in your list
		nz: 'NZ',
		za: 'ZA',
		gb: 'GB',
		us: 'US',
		ch: 'CH',
		eu: 'AU'    // "International ($AUD)" — pick AU so currency stays AUD; adjust if needed
	};

	function fromHandle(handle) {
		return HANDLE_TO_COUNTRY[handle] || null;
	}

	// 3) Last-ditch: parse the visible label (e.g., "Australia ($AUD)") to an ISO
	var NAME_TO_COUNTRY = {
		'australia': 'AU',
		'canada': 'CA',
		'europe': 'DE',     // pick DE as a representative country for "Europe" option
		'germany': 'DE',
		'new zealand': 'NZ',
		'south africa': 'ZA',
		'united kingdom': 'GB',
		'uk': 'GB',
		'united states': 'US',
		'usa': 'US',
		'switzerland': 'CH',
		'international': 'AU' // using AU to match AUD; adjust if you change that option
	};

	function normalizeText(s) {
		return String(s || '')
			.toLowerCase()
			.replace(/\(.*?\)/g, '') // drop "($AUD)" etc.
			.replace(/[^a-z\s]/g, '')
			.trim();
	}

	function fromLabel(optionEl) {
		if (!optionEl) return null;
		var label = normalizeText(optionEl.textContent || optionEl.innerText || '');
		// try exact match first
		if (NAME_TO_COUNTRY[label]) return NAME_TO_COUNTRY[label];
		// try first two words (e.g., "united kingdom")
		var parts = label.split(/\s+/).slice(0, 2).join(' ');
		if (NAME_TO_COUNTRY[parts]) return NAME_TO_COUNTRY[parts];
		// try first word
		var first = (label.split(/\s+/)[0] || '');
		if (NAME_TO_COUNTRY[first]) return NAME_TO_COUNTRY[first];
		return null;
	}

	function resolveISO(optionEl) {
		// Priority: data-country -> handle map -> label map -> current value
		var dataIso = fromDataAttr(optionEl);
		if (dataIso) return dataIso;

		var handle = optionEl ? optionEl.value : '';
		var isoFromHandle = fromHandle(handle);
		if (isoFromHandle) return isoFromHandle;

		var isoFromLabel = fromLabel(optionEl);
		if (isoFromLabel) return isoFromLabel;

		// fallback to whatever is already in the hidden input
		var currentISO = (countryInput.value || '').toUpperCase();
		return /^[A-Z]{2}$/.test(currentISO) ? currentISO : '';
	}

	select.addEventListener('change', function() {
		var optionEl = select.options[select.selectedIndex];
		if (!optionEl) return;

		var iso = resolveISO(optionEl);
		if (!iso) return; // we couldn't resolve a country; do nothing

		countryInput.value = iso;
		form.submit();
	});
})();




const playButtons = document.querySelectorAll('.video-overlay');
const pauseButtons = document.querySelectorAll('.video-pause-button');

playButtons.forEach(button => {
	button.addEventListener('click', () => {
		const videoWrap = button.closest('.video-wrap');
		const video = videoWrap.querySelector('video');
		const videoPause = videoWrap.querySelector('.video-pause-button');

		if (video) {
			video.play();
		}
		button.style.display = 'none';
		videoPause.style.display = 'flex';
	});
});

pauseButtons.forEach(button => {
	button.addEventListener('click', () => {
		const videoWrap = button.closest('.video-wrap');
		const video = videoWrap.querySelector('video');
		const videoPlay = videoWrap.querySelector('.video-play-button');
		const videoOverlay = videoWrap.querySelector('.video-overlay');

		if (video) {
			video.pause();
		}
		button.style.display = 'none';
		videoOverlay.style.display = 'flex';
	});
});

function section_social_videos(videoSection){

	//console.log('video section')
	const videoPlayers = videoSection.querySelectorAll("video"); // Get all video elements
	let currentVideoIndex = videoPlayers.length;
	let videos_loaded = false

	function playNextVideo() {

		//console.log('playing:'+currentVideoIndex)

		currentVideoIndex++;

		//console.log('playing2:'+currentVideoIndex)


		if (currentVideoIndex >= videoPlayers.length) {
			currentVideoIndex = 0; // Loop back to the beginning
		}

		for (var i = 0; i < videoPlayers.length; i++) {
			videoPlayers[i].closest('li').classList.remove('active');
		}

		const current_video = videoPlayers[currentVideoIndex]

		for (var source in current_video.children) {
			const videoSource = current_video.children[source];
			if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
				videoSource.src = videoSource.dataset.src;
			}
		}

		current_video.closest('li').classList.add('active');
		current_video.play();
	}

	for (var i = 0; i < videoPlayers.length; i++) {
		videoPlayers[i].addEventListener("ended", playNextVideo);
	}

	function loadVideos() {
		//console.log('loaidng:'+videos_loaded)
		if (videos_loaded == false) {
			videos_loaded = true;
			//Preload videos
			for (var i = 0; i < videoPlayers.length; i++) {
				const current_video = videoPlayers[i]

				for (var source in current_video.children) {
					const videoSource = current_video.children[source];
					if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
						videoSource.src = videoSource.dataset.src;
					}
				}
				current_video.load();
			}
		}
	}

	const scrollHandler = function() {
		if (videoSection) {
			const isInView = videoSection.getBoundingClientRect().top >= 0 &&
			videoSection.getBoundingClientRect().bottom <= window.innerHeight;

			if (isInView) {
				loadVideos();
				playNextVideo();

				window.removeEventListener('scroll', scrollHandler);
			}
		}
	}
	window.addEventListener('scroll', scrollHandler);
}

const videoSections = document.querySelectorAll(".autoplay-videos"); // Get all video sections

for (var i = 0; i < videoSections.length; i++) {
	section_social_videos(videoSections[i])
}


document.addEventListener('change', event => {
	if (!event.target.matches('.shipping-protection input[type="checkbox"]')) return;
	const protection = event.target.closest('.shipping-protection');
	setCookie('shipping_protection', String(event.target.checked), 1);
	if (!event.target.checked && protection.dataset.cartKey) {
		updateCartLine(protection.dataset.cartKey, 0);
	} else if (event.target.checked && protection.dataset.variantId) {
		addProductToCart(protection.dataset.variantId);
	}
});



const headerCustom = document.querySelector('.site-header-wrapper');
if (headerCustom){
	let
		prevScroll = 0,
		scroll_y_max = 100;

	function handleScroll() {
		if ( prevScroll == 0){
			scroll_y_max = 21;
		} else {
			scroll_y_max = 100;
		}
		prevScroll = window.scrollY;

		if (window.scrollY < 20) {
			headerCustom.classList.remove('sticky');
		}
		else if (window.scrollY > scroll_y_max) {
			headerCustom.classList.add('sticky');
		}
	}

	window.addEventListener('scroll', handleScroll);

	/* Custom Functionality to Open Menu */
	const menuButtonOpen = document.querySelector('.site-header-menu-button');
	const menuButtonClose = document.querySelector('.mobile-nav-close');
	const websiteBody = document.querySelector('body');
	const mobileNav = document.querySelector('.site-mobile-nav');
	const mobileNavOverlay = document.querySelector('.mobile-nav-overlay');
	let mobileNavItemsAnimationTimeout;

	function openMobileMenu() {
		clearTimeout(mobileNavItemsAnimationTimeout);
		websiteBody.classList.add('scroll-lock');
		mobileNav.classList.add('animating');
		mobileNav.classList.add('animating-in');
		mobileNav.classList.add('menu-items-animating');

		setTimeout(function () {
			mobileNav.classList.remove('animating');
			mobileNav.classList.remove('animating-in');
			mobileNav.classList.add('visible');
		}, 400);

		mobileNavItemsAnimationTimeout = setTimeout(function () {
			mobileNav.classList.remove('menu-items-animating');
		}, 1200);
	}

	function closeMobileMenu() {
		clearTimeout(mobileNavItemsAnimationTimeout);
		mobileNav.classList.remove('menu-items-animating');
		websiteBody.classList.remove('scroll-lock');
		mobileNav.classList.add('animating');
		mobileNav.classList.add('animating-out');

		setTimeout(function () {
			mobileNav.classList.remove('animating');
			mobileNav.classList.remove('animating-out');
			mobileNav.classList.remove('visible');
		}, 300);
	}

	if (menuButtonOpen){
		menuButtonOpen.addEventListener('click', openMobileMenu);
	}
	if (menuButtonClose){
		menuButtonClose.addEventListener('click', closeMobileMenu);
	}
	if (mobileNavOverlay){
		mobileNavOverlay.addEventListener('click', closeMobileMenu);
	}

	const mobileNavContent = document.querySelector('.mobile-nav-content');
	if (mobileNavContent){
		mobileNavContent.addEventListener('click', function(event) {
			if (event.target.classList.contains('navmenu-button')) {
				const buttonElement = event.target;
				const prevLink = buttonElement.previousElementSibling;
				const parentLink = buttonElement.closest('.navmenu-item-parent');
				const subMenu = parentLink && parentLink.querySelector('.navmenu-submenu');

				if (!subMenu) return;

				if (prevLink) {
					prevLink.classList.toggle('navmenu-link-parent-active', !subMenu.classList.contains('visible'));
				}

				if (subMenu.classList.contains('visible')) {
					subMenu.classList.add('is-closing');
					setTimeout(function () {
						subMenu.classList.remove('visible', 'is-closing');
					}, 200);
				} else {
					subMenu.classList.remove('is-closing');
					subMenu.classList.add('visible');
				}
			}
		});
	}


	const navSearch = document.querySelector('.site-header-search-wrapper');
	const navSearchBtn = document.querySelector('.site-header-search-button');
	const liveSearch = document.querySelector('.live-search');
	const liveSearchBtn = document.querySelector('.live-search-button');
	const closeSearch = document.querySelector('.site-header-search-close');
	const closeSearchMobile = document.querySelector('.live-search-takeover-cancel');


	function OpenNavSearch() {
		navSearch.classList.add('show-search');
		liveSearch.classList.add('live-search--focused','live-search--active');
	}
	function CloseNavSearch() {
		navSearch.classList.remove('show-search');
		liveSearch.classList.remove('live-search--focused','live-search--active');
	}
	if (navSearchBtn){
		navSearchBtn.addEventListener('click', OpenNavSearch);
	}
	if (closeSearch){
		closeSearch.addEventListener('click', CloseNavSearch);
	}
	if (closeSearchMobile){
		closeSearchMobile.addEventListener('click', CloseNavSearch);
	}

		function search_results(query){
			const searchUrl = new URL('/search', window.location.origin);
			searchUrl.searchParams.set('q', query);
			searchUrl.searchParams.set('sections', 'static-search');

			fetch(searchUrl.toString())
		.then(response => response.text())
		.then(html => {
			//console.log(JSON.parse(html))

			const parsedHTML = JSON.parse(html)
			//console.log('new cart:')

			var search_section = 'static-search'

			const parsedSection = parsedHTML[search_section]

			var parser = new DOMParser();
			var sectionHTML = parser.parseFromString(parsedSection, 'text/html');

			const product_results = sectionHTML.querySelector('.productgrid--items');

			document.querySelector(".search-flydown").innerHTML = "";
			document.querySelector(".search-flydown").appendChild(product_results);

			liveSearchBtn.classList.remove('search-icon--processing');
		});
	}

	const liveSearchInput = document.querySelector('.live-search-form-field');
	let searchInputTimeout = null;

	if (liveSearchInput){
		liveSearchInput.addEventListener('input', function() {
			liveSearchBtn.classList.add('search-icon--processing');

			clearTimeout(searchInputTimeout);

			searchInputTimeout = setTimeout(() => {
				search_results(this.value)
			}, 1000);
		});
	}

	function searchMobileTakeover() {
		const liveSearchElement = document.querySelector('.live-search');

		if (liveSearchElement){
			if (window.innerWidth < 751) {
				liveSearchElement.classList.add('live-search--takeover');
			} else {
				liveSearchElement.classList.remove('live-search--takeover');
			}
		}
	}

	setTimeout(function () {
		searchMobileTakeover();
	}, 1000);

	window.addEventListener('resize', searchMobileTakeover);
}

/* Countdown timers */
function countdownTimer(target,targetDate){
	const countDownDate = new Date(targetDate).getTime();
	const hourlyReset = target.dataset.hourlyReset === 'true';

	//Local timezone offset
	const LocalzoneOffset = new Date().getTimezoneOffset() * 60 * 1000;

	//AU Offset in Mins
	const AUoffset = 10 * 60
	const AUzoneOffset = AUoffset  * 60 * 1000;

	const timezoneOffset = AUzoneOffset + LocalzoneOffset;

	function getTimeLeft(now) {
		// if Hourly Reset off
		if (!hourlyReset) return countDownDate - now;

		// For Hourly Reset
		const nextHour = Math.floor(now / (1000 * 60 * 60)) * (1000 * 60 * 60) + (1000 * 60 * 60);
		const effectiveTarget = Math.min(countDownDate, nextHour);
		return effectiveTarget - now;
	}

	function calculateTime(){
		// Get today's date and time
		let now = new Date().getTime();

		//console.log( Math.floor((timezoneOffset % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) )
		now += timezoneOffset;

		// Find the timeLeft between now and the active countdown target
		const timeLeft = getTimeLeft(now);

		// Time calculations for days, hours, minutes and seconds
		let days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
		let hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
		let minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
		let seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

		if (days < 10) { days = '0'+days }
		if (hours < 10) { hours = '0'+hours }
		if (minutes < 10) { minutes = '0'+minutes }
		if (seconds < 10) { seconds = '0'+seconds }

      	// If the count down is finished, hide
		if (countDownDate - now < 0) {
		  clearInterval(cd_interval);
		  target.style.display = 'none'; // Hide directly
		} else {
		  target.classList.remove('loading');
		  target.innerHTML = `<span class="time-${days}">${days}</span><span>:</span><span>${hours}</span><span>:</span><span>${minutes}</span><span>:</span><span>${seconds}</span>`;
		}
	}

	calculateTime();

    // Update the count down every 1 second
    var cd_interval = setInterval(function() {
		calculateTime();
    }, 1000);
}

const countdownTimers = document.querySelectorAll('.countdown-timer');

countdownTimers.forEach(timerElement => {
	countdownTimer(timerElement,timerElement.dataset.date);
});

const swatchWrapper = document.querySelector('.swatch-wrapper');
if ( swatchWrapper ) {
	setTimeout(function () {
		swatchWrapper.classList.add('loaded');
	}, 1000);
}

function syncProductCardSwatchMoreButtons() {
	document.querySelectorAll('[data-product-card-swatches]').forEach(function(swatchList) {
		const moreButton = swatchList.querySelector('[data-product-card-swatches-more]');
		if (!moreButton) return;

		if (swatchList.classList.contains('is-expanded')) {
			moreButton.hidden = true;
			return;
		}

		const hiddenSwatches = Array.from(swatchList.querySelectorAll('[data-product-card-swatch]')).filter(function(item) {
			return window.getComputedStyle(item).display === 'none';
		});

		moreButton.hidden = hiddenSwatches.length === 0;
	});
}

document.addEventListener('DOMContentLoaded', syncProductCardSwatchMoreButtons);
window.addEventListener('resize', syncProductCardSwatchMoreButtons);

document.addEventListener('click', function(event) {
	const moreButton = event.target.closest('[data-product-card-swatches-more]');
	if (moreButton) {
		const swatchList = moreButton.closest('[data-product-card-swatches]');
		if (!swatchList) return;

		swatchList.classList.add('is-expanded');
		moreButton.setAttribute('aria-expanded', 'true');
		moreButton.hidden = true;
		syncProductCardSwatchMoreButtons();
		return;
	}

	const swatch = event.target.closest('[data-product-card-swatch]');
	if (!swatch) return;

	event.preventDefault();

	const productCard = swatch.closest('.productitem');
	if (!productCard) return;

	const productUrl = swatch.getAttribute('href');
	if (!productUrl) return;

	productCard.querySelectorAll('[data-product-card-swatch]').forEach(function(item) {
		item.classList.toggle('selected', item === swatch);
		if (item === swatch) {
			item.setAttribute('aria-current', 'page');
		} else {
			item.removeAttribute('aria-current');
		}
	});

	getProductCardSwatchData(productUrl, productCard).then(function(productData) {
		if (!productData) return;
		if (!swatch.classList.contains('selected')) return;
		updateProductCardFromSwatch(productCard, productData);
	});
});

function normalizeProductPath(url) {
	const link = document.createElement('a');
	link.href = url;
	return link.pathname.replace(/\/$/, '');
}

function getProductHandleFromPath(url) {
	const pathParts = normalizeProductPath(url).split('/');
	return pathParts[pathParts.length - 1];
}

function getSizedShopifyImageUrl(src, size) {
	if (!src) return '';

	const cleanSrc = src.split('?')[0];
	const queryString = src.includes('?') ? '?' + src.split('?').slice(1).join('?') : '';
	return cleanSrc.replace(/(_[0-9]+x[0-9]*|_[0-9]*x[0-9]+|_master)?(\.[a-zA-Z0-9]+)$/, '_' + size + '_crop_center$2') + queryString;
}

function getProductCardSrcset(src) {
	return [
		getSizedShopifyImageUrl(src, '360x') + ' 360w',
		getSizedShopifyImageUrl(src, '540x') + ' 540w',
		getSizedShopifyImageUrl(src, '720x') + ' 720w',
		getSizedShopifyImageUrl(src, '900x') + ' 900w',
		getSizedShopifyImageUrl(src, '1200x') + ' 1200w'
	].join(', ');
}

function getProductCardSwatchDataFromPage(productUrl, currentCard) {
	const productHandle = getProductHandleFromPath(productUrl);
	const cards = document.querySelectorAll('.productitem');

	for (const card of cards) {
		if (card === currentCard) continue;

		const link = card.querySelector('[data-product-card-link]');
		if (!link || getProductHandleFromPath(link.href) !== productHandle) continue;

		const primaryImage = card.querySelector('.productitem--image-primary');
		const secondaryImage = card.querySelector('.productitem--image-alternate');
		const variantInput = card.querySelector('[data-product-card-variant-id]');
		const titleMain = card.querySelector('[data-product-card-title-main]');
		const titleSubtitle = card.querySelector('[data-product-card-title-subtitle]');

		return {
			url: productUrl,
			available: card.dataset.productAvailable === 'true',
			title: link.getAttribute('aria-label') ? link.getAttribute('aria-label').replace(/^View /, '') : (titleMain ? titleMain.textContent.trim() : ''),
			titleMain: titleMain ? titleMain.textContent.trim() : '',
			titleSubtitle: titleSubtitle && !titleSubtitle.hidden ? titleSubtitle.textContent.trim() : '',
			variantId: variantInput ? variantInput.value : '',
			primaryImage: primaryImage ? {
				src: primaryImage.currentSrc || primaryImage.src,
				srcset: primaryImage.srcset,
				width: primaryImage.getAttribute('width'),
				height: primaryImage.getAttribute('height'),
				alt: primaryImage.alt
			} : null,
			secondaryImage: secondaryImage && !secondaryImage.hidden && secondaryImage.getAttribute('src') ? {
				src: secondaryImage.currentSrc || secondaryImage.src,
				srcset: secondaryImage.srcset,
				width: secondaryImage.getAttribute('width'),
				height: secondaryImage.getAttribute('height'),
				alt: secondaryImage.alt
			} : null
		};
	}

	return null;
}

function getProductCardSwatchDataFromAjax(productUrl, useProductContentShortTitle) {
	const handle = getProductHandleFromPath(productUrl);
	if (!handle) return Promise.resolve(null);

	return fetch('/products/' + handle + '.js', {
		credentials: 'same-origin',
		headers: {
			'Accept': 'application/json'
		}
	}).then(function(response) {
		if (!response.ok) return null;
		return response.json();
	}).then(function(product) {
		if (!product) return null;

		const primaryImage = product.images && product.images[0] ? product.images[0] : null;
		const secondaryImage = product.images && product.images[1] ? product.images[1] : null;
		const variant = product.variants && product.variants[0] ? product.variants[0] : null;
		const titleParts = product.title.split(' - ');

		return {
			url: productUrl,
			available: product.available,
			title: product.title,
			titleMain: useProductContentShortTitle ? '' : (titleParts[1] || titleParts[0] || '').replace(' with Straps', ''),
			titleSubtitle: useProductContentShortTitle ? (titleParts[0] || '') : (titleParts[1] ? titleParts[0] : ''),
			variantId: variant ? variant.id : '',
			primaryImage: primaryImage ? {
				src: getSizedShopifyImageUrl(primaryImage, '600x'),
				srcset: getProductCardSrcset(primaryImage),
				alt: product.title
			} : null,
			secondaryImage: secondaryImage ? {
				src: getSizedShopifyImageUrl(secondaryImage, '600x'),
				srcset: getProductCardSrcset(secondaryImage),
				alt: product.title
			} : null
		};
	}).catch(function() {
		return null;
	});
}

function getProductCardSwatchData(productUrl, currentCard) {
	const pageData = getProductCardSwatchDataFromPage(productUrl, currentCard);
	if (pageData) return Promise.resolve(pageData);

	return getProductCardSwatchDataFromAjax(
		productUrl,
		currentCard.classList.contains('productitem--short-title')
	);
}

function updateProductCardFromSwatch(productCard, productData) {
	const primaryImage = productCard.querySelector('.productitem--image-primary');
	const secondaryImage = productCard.querySelector('.productitem--image-alternate');
	const variantInput = productCard.querySelector('[data-product-card-variant-id]');
	const titleMain = productCard.querySelector('[data-product-card-title-main]');
	const titleSubtitle = productCard.querySelector('[data-product-card-title-subtitle]');
	const soldOutBadge = productCard.querySelector('.productitem--badge.badge--soldout');

	productCard.dataset.productAvailable = String(productData.available);
	if (productData.available) {
		if (soldOutBadge) soldOutBadge.remove();
	} else if (!soldOutBadge) {
		const badge = document.createElement('span');
		badge.className = 'badge badge--compact productitem--badge badge--soldout';
		badge.textContent = productCard.dataset.soldOutLabel;
		productCard.querySelector('.productitem--image').appendChild(badge);
	}

	productCard.querySelectorAll('[data-product-card-link]').forEach(function(link) {
		link.href = productData.url;
		if (link.hasAttribute('aria-label')) {
			link.setAttribute('aria-label', 'View ' + productData.title);
		}
	});

	if (titleMain && productData.titleMain) {
		titleMain.textContent = productData.titleMain;
	}

	if (titleSubtitle) {
		if (productData.titleSubtitle) {
			titleSubtitle.textContent = productData.titleSubtitle;
			titleSubtitle.hidden = false;
		} else {
			titleSubtitle.textContent = '';
			titleSubtitle.hidden = true;
		}
	}

	if (primaryImage && productData.primaryImage) {
		primaryImage.src = productData.primaryImage.src;
		primaryImage.srcset = productData.primaryImage.srcset || '';
		if (productData.primaryImage.width) primaryImage.width = productData.primaryImage.width;
		if (productData.primaryImage.height) primaryImage.height = productData.primaryImage.height;
		primaryImage.alt = productData.primaryImage.alt || productData.title || '';
	}

	if (secondaryImage) {
		if (productData.secondaryImage) {
			secondaryImage.hidden = false;
			secondaryImage.src = productData.secondaryImage.src;
			secondaryImage.srcset = productData.secondaryImage.srcset || '';
			if (productData.secondaryImage.width) secondaryImage.width = productData.secondaryImage.width;
			if (productData.secondaryImage.height) secondaryImage.height = productData.secondaryImage.height;
			secondaryImage.alt = productData.secondaryImage.alt || productData.title || '';
		} else {
			secondaryImage.hidden = true;
			secondaryImage.removeAttribute('srcset');
			secondaryImage.removeAttribute('src');
		}
	}

	if (variantInput && productData.variantId) {
		variantInput.value = productData.variantId;
	}
}

function updateFeaturedProductSwatchState(featuredProduct, selectedSwatch) {
	featuredProduct.querySelectorAll('.swatch-wrapper .swatch-item').forEach(function(item) {
		item.classList.toggle('selected', item === selectedSwatch);

		if (item === selectedSwatch) {
			item.setAttribute('aria-current', 'page');
		} else {
			item.removeAttribute('aria-current');
		}
	});
}

function getFeaturedProductMarkup(productUrl, sectionId) {
	if (!sectionId) return Promise.resolve(null);

	const sectionUrl = new URL(productUrl, window.location.origin);
	sectionUrl.searchParams.set('sections', sectionId);

	return fetch(sectionUrl.toString(), {
		credentials: 'same-origin'
	}).then(function(response) {
		if (!response.ok) return null;
		return response.json();
	}).then(function(sections) {
		const html = sections && sections[sectionId];
		if (!html) return null;

		const parser = new DOMParser();
		const doc = parser.parseFromString(html, 'text/html');
		const incomingFeaturedProduct = doc.querySelector('.featured-product--container');
		const incomingProductContent = incomingFeaturedProduct || doc;

		return {
			productUrl: productUrl,
			featuredProduct: incomingFeaturedProduct,
			galleryColumn: incomingProductContent.querySelector('.product_gallery-column'),
			price: incomingProductContent.querySelector('#product-price-selector'),
			atc: incomingProductContent.querySelector('.product-form--atc'),
			stockProgress: incomingProductContent.querySelector('.product-stock-progress'),
			preorderMessage: incomingProductContent.querySelector('.preorder-message.po-4'),
			variantId: incomingProductContent.querySelector('#selected-variant-id'),
			stickyAtc: incomingProductContent.querySelector('#sticky-add-to-cart'),
			sizeSelector: incomingProductContent.querySelector('.product-size-selector')
		};
	}).catch(function() {
		return null;
	});
}

function updateFeaturedProductFromSwatch(featuredProduct, productMarkup) {
	if (!featuredProduct || !productMarkup) return;

	if (productMarkup.featuredProduct) {
		featuredProduct.className = productMarkup.featuredProduct.className;
	}

	const currentGalleryColumn = featuredProduct.querySelector('.product_gallery-column');
	if (currentGalleryColumn && productMarkup.galleryColumn) {
		currentGalleryColumn.replaceWith(productMarkup.galleryColumn.cloneNode(true));
		if (typeof window.refreshProductGallery === 'function') {
			window.refreshProductGallery();
		}
	}

	const currentPrice = featuredProduct.querySelector('#product-price-selector');
	if (currentPrice && productMarkup.price) {
		currentPrice.replaceWith(productMarkup.price.cloneNode(true));
		featuredProduct.querySelector('[data-multi-buy]')?.dispatchEvent(new Event('multi-buy:update'));
	}

	const currentAtc = featuredProduct.querySelector('.product-form--atc');
	if (currentAtc && productMarkup.atc) {
		currentAtc.replaceWith(productMarkup.atc.cloneNode(true));
	}

	featuredProduct.querySelectorAll('.product-all-features a, .product-video-all-features a, .product-learn-more-btn').forEach(function(link) {
		link.setAttribute('href', productMarkup.productUrl);
	});

	const currentSizeSelector = featuredProduct.querySelector('.product-size-selector');
	if (currentSizeSelector?.dataset.sizeNavigation === 'product' && productMarkup.sizeSelector) {
		currentSizeSelector.replaceWith(productMarkup.sizeSelector.cloneNode(true));
	}

	const currentStickyAtc = featuredProduct.querySelector('#sticky-add-to-cart');
	if (currentStickyAtc && productMarkup.stickyAtc) {
		const currentInfo = currentStickyAtc.querySelector('.sticky-info');
		const incomingInfo = productMarkup.stickyAtc.querySelector('.sticky-info');
		if (currentInfo && incomingInfo) {
			currentInfo.innerHTML = incomingInfo.innerHTML;
		}

		// Keep the existing controls and sticky wrapper so their listeners remain attached.
		const currentButton = currentStickyAtc.querySelector('#sticky-atc');
		const incomingButton = productMarkup.stickyAtc.querySelector('#sticky-atc');
		if (currentButton && incomingButton) {
			currentButton.innerHTML = incomingButton.innerHTML;
			currentButton.disabled = incomingButton.disabled;
		}

		const stickyQuantity = currentStickyAtc.querySelector('#product-quantity-select-sticky');
		const mainQuantity = featuredProduct.querySelector('#product-quantity-select');
		if (stickyQuantity && mainQuantity) {
			stickyQuantity.value = mainQuantity.value;
		}
	}

	const currentStockProgress = featuredProduct.querySelector('.product-stock-progress');
	if (currentStockProgress && productMarkup.stockProgress) {
		currentStockProgress.replaceWith(productMarkup.stockProgress.cloneNode(true));
	} else if (currentStockProgress) {
		currentStockProgress.remove();
	} else if (productMarkup.stockProgress) {
		featuredProduct.querySelector('.product-form--atc')?.after(productMarkup.stockProgress.cloneNode(true));
	}

	const currentPreorderMessage = featuredProduct.querySelector('.preorder-message.po-4');
	if (currentPreorderMessage && productMarkup.preorderMessage) {
		currentPreorderMessage.replaceWith(productMarkup.preorderMessage.cloneNode(true));
	}

	const currentVariantId = featuredProduct.querySelector('#selected-variant-id');
	if (currentVariantId && productMarkup.variantId) {
		currentVariantId.replaceWith(productMarkup.variantId.cloneNode(true));
	}
}

/* featured product swatch update product */
document.addEventListener('click', function(event) {
	const swatch = event.target.closest('.featured-product--container .swatch-wrapper .swatch-item');
	if (!swatch) return;

	if (swatch.classList.contains('swatch-special')) return;

	const featuredProduct = swatch.closest('.featured-product--container');
	if (!featuredProduct || featuredProduct.classList.contains('is-loading')) {
		event.preventDefault();
		return;
	}

	const featuredSection = featuredProduct.closest('.shopify-section');
	const featuredSectionId = featuredSection && featuredSection.id
		? featuredSection.id.replace(/^shopify-section-/, '')
		: '';

	const productUrl = swatch.getAttribute('href');
	if (!productUrl || !featuredSectionId || swatch.classList.contains('selected')) {
		event.preventDefault();
		return;
	}

	event.preventDefault();

	featuredProduct.classList.add('is-loading');
	updateFeaturedProductSwatchState(featuredProduct, swatch);

	getFeaturedProductMarkup(productUrl, featuredSectionId).then(function(productMarkup) {
		if (!productMarkup) {
			window.location.href = productUrl;
			return;
		}
		updateFeaturedProductFromSwatch(featuredProduct, productMarkup);
	}).finally(function() {
		featuredProduct.classList.remove('is-loading');
	});
});


const formFieldInputs = document.querySelectorAll('.form-field-input');

formFieldInputs.forEach(input => {
	input.addEventListener('input', function() {
		if (this.value.trim() !== "") {
			this.classList.add('form-field-filled');
		} else {
			this.classList.remove('form-field-filled');
		}
	});
});

// Helper function to check if the element is in the viewport
function isInViewport(element) {
  const rect = element.getBoundingClientRect();
  return rect.top >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight);
}

function easeOutExpo(t) {
  return 1 - Math.pow(1 - t, 20); // Replace 5 with a higher number for stronger slow-down
}

function easeOutCubic(t) {
  return 1 - Math.pow(1 - t, 3);
}

function getCounterEasing(easingName) {
  if (easingName === "linear") {
    return function(t) {
      return t;
    };
  }

  if (easingName === "easeOutCubic") {
    return easeOutCubic;
  }

  return easeOutExpo;
}

function animateCounter(element, start, end, duration, easingName) {
  let startTime = null;
  const easing = getCounterEasing(easingName);

  function updateCounter(currentTime) {
    if (!startTime) startTime = currentTime;
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);
    const easedProgress = easing(progress);

    const value = Math.floor(easedProgress * (end - start) + start);
    element.textContent = value.toLocaleString();

    if (progress < 1) {
      requestAnimationFrame(updateCounter);
    }
  }

  requestAnimationFrame(updateCounter);
}

// Scroll event listener
document.addEventListener("scroll", () => {
  const counters = document.querySelectorAll(".counter");
  counters.forEach((counter) => {
    if (isInViewport(counter) && !counter.classList.contains("counted")) {
    const start = parseInt(counter.getAttribute("data-start"), 10);
    const end = parseInt(counter.getAttribute("data-end"), 10);
    const duration = parseInt(counter.getAttribute("data-duration"), 10) || 20000;
    const easing = counter.getAttribute("data-counter-easing") || "easeOutExpo";
    counter.classList.add("counted");
    animateCounter(counter, start, end, duration, easing);
    }
  });
});

// Accordions
function setAccordionState(trigger, open) {
	const accordion = trigger.closest('.accordion');
	const panel = accordion?.querySelector('.accordion-content');
	if (!panel) return;

	accordion.classList.toggle('is-open', open);
	trigger.setAttribute('aria-expanded', String(open));
	panel.setAttribute('aria-hidden', String(!open));
}

// Delegation also covers product content inserted by swatch/section rendering.
document.addEventListener('click', (event) => {
	const trigger = event.target.closest('.accordion-trigger');
	if (!trigger) return;

	const open = trigger.getAttribute('aria-expanded') !== 'true';
	const group = trigger.closest('[data-accordion-exclusive]');
	if (group && open) {
		for (const sibling of group.querySelectorAll('.accordion-trigger')) {
			if (sibling !== trigger) setAccordionState(sibling, false);
		}
	}
	setAccordionState(trigger, open);
});
